import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';

import Utils from 'src/app/utils';

@Component({
  selector: 'app-awards-companyrankings',
  templateUrl: './companyrankings.component.html',
  styleUrls: ['./companyrankings.component.scss']
})
export class CompanyrankingsComponent implements OnInit {

  rankings: any;
  @Input() month = null;

  u = Utils;

  constructor(public okService: OkAloneService) { }

  ngOnInit(): void {

    this.getCompanyRankings();

  }
  ngOnChanges(changes: SimpleChanges) {
    this.getCompanyRankings();
  }

  getCompanyRankings(){

    this.okService.get("awards/companyrankings",{month:this.month})
    .subscribe((data) => {

      this.rankings = data.body;

      //console.log('getCompRankings', this.rankings);

    });

  }

}
